import { ANNOUNCEMENTS_ENDPOINT } from "Constants";
import { baseApi as api } from "Services";
import { Announcement } from "Types";

type ApiResponse = {
  announcements: Announcement[];
};

export const announcementsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAnnouncements: builder.query<ApiResponse, void>({
      query: () => ({ url: `${ANNOUNCEMENTS_ENDPOINT}/announcements` }),
    }),
  }),
});

export const { useGetAnnouncementsQuery } = announcementsApi;
